// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//入口文件
import Vue from 'vue'
//导入APP根组件
import App from './App'
import router from './router'
import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import  "../static/css/home.less"
import BaiduMap from 'vue-baidu-map'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import './assets/fonts/font.css'


Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BaiduMap, {
  // ak: "rQxHPQX1ua21rWnXzTbUh5KSSUbnefxR"
  ak: "LfbGVIFnArDrXL2MXmS4Ylzgk1FzLZcQ"
})
Vue.use(ElementUI);
// Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js